import type { PaginationSEOLink } from 'types/seo'
import { externalStorefronts } from '../configuration/storefronts.configuration'

export function generateExternalStorefrontHreflangs(): PaginationSEOLink[] {
  const externalHreflangs: PaginationSEOLink[] = []

  externalStorefronts.forEach((storefront) => {
    const hreflang = `${storefront.language}-${storefront.storefrontCode.toLowerCase()}`

    externalHreflangs.push({
      hid: `alternate:${hreflang}`,
      rel: 'alternate',
      hrefLang: hreflang,
      href: storefront.externalRedirect,
    })
  })

  return externalHreflangs
}
